import { type CSSProperties, useEffect, useState } from "react";

import { useTourContext } from "./TourController";

/**
 * A hook for getting state and styles for hiding elements during a tour.
 * Elements stay hidden until they're remounted.
 */
export default function useHideDuringAndAfterTour() {
	const { activeTour } = useTourContext();

	const [isHidden, setHidden] = useState(false);

	useEffect(() => {
		if (activeTour) setHidden(true);
	}, [activeTour]);

	return {
		isHidden,
		hiddenStyles: !isHidden
			? {}
			: ({
					display: "none",
				} satisfies CSSProperties),
	};
}
